import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InputFileComponent } from "./input-file.component";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  exports: [InputFileComponent],
  declarations: [InputFileComponent],
  imports: [CommonModule, FormsModule, TranslateModule],
})
export class InputFileModule {}
